import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import {
  getMenus,
  findPane,
  filterSubMenus
} from '@/store/_util/util'
// api
import { switchSystemCode } from '@/api/sso/subjectService'
import { getMenuTreeByServiceAndRole, queryECMenuTreeByPlatformCode } from '@/api/sso/role'
import { i18nRender } from '@/locales'
import md5 from 'md5'
import {
  customGroupQueryList,
  customGroupQuery,
  customGroupAdd,
  customGroupDel,
  customGroupEdit,
  bindMenuCustomMenu,
  collectMenu,
  addFavorites,
  delFavorites,
  queryFavorites
} from '@/api/sso/customGroup'
import {
  recordMenuOpt
} from '@/api'
// types
import {
  PANES_CACHE,
  PANES_HISTORY_CACHE,
  ACTIVE_KEY_CACHE,
  MENUS_ACTIVE_ID_CACHE,
  LANGUAGE,
  // USER_INFO,
  HOME_MENU_ID
  // ACCESS_TOKEN
} from '@/store/mutation-types'

import modal from 'ant-design-vue/es/modal'
import { initTabStack, getTagStackTop, pushTabStack } from '@/utils/tabStack.js'

const entry = {
  namespaced: true,
  state: {
    activePane: {},
    serviceId: '',
    systemCode: '',
    menus: [], // 用户系统菜单
    subMenus: [], // 子菜单-按钮权限菜单
    // useNewMenu: 2, // 1 侧边菜单布局；旗舰版菜单布局是：2 顶部菜单布局
    menusCache: {},
    menusActiveID: '',
    customMenusDefault: [], // 系统默认的菜单
    customMenus: [], // 用户自定义菜单
    activeKey: 'home',
    homeMenuId: 'home',
    // unfold: false, // 展开（true）| 收缩（false）左侧菜单
    menuTypeCurrentId: -1, // 菜单变身选中值
    panes: [], // [{ key: menuId, tab: menuName, systemDomain: systemDomain, path: path, menuUrl: menuUrl, closable: true }]
    iframes: [], // [{ key: menuId, tab: menuName, systemDomain: systemDomain, path: path, menuUrl: menuUrl, closable: true }]
    panesHistory: [], // 缓存用户打开过的10个标签
    favorites: [], // 收藏夹
    paidPageFlag: 2 // 是否显示付费页面 1 | 2
  },
  mutations: {
    SET_FAVORITES (state, favorites) {
      state.favorites = favorites
    },
    ADD_FAVORITES (state, { key }) {
      const index = state.favorites.map(item => item.key).indexOf(key)

      if (index === -1) {
        const pane = findPane(state.menus, { key, lastMenu: 2 })
        pane && state.favorites.push(pane)
      }
    },
    DEL_FAVORITES (state, { key }) {
      const index = state.favorites.map(item => item.key).indexOf(key)
      ~index && state.favorites.splice(index, 1)
    },
    SET_HOME_MENU_ID: (state, homeMenuId) => {
      state.homeMenuId = homeMenuId
      Vue.ls.set(HOME_MENU_ID, homeMenuId)
    },
    SET_SERVICE_ID: (state, id) => {
      state.serviceId = id
    },
    SET_SYSTEM_CODE: (state, code) => {
      state.systemCode = code
    },
    SET_CUSTOM_MENUS: (state, menus) => {
      state.customMenus = menus
    },
    SET_PANES: (state, panes) => {
      state.panes = panes
    },
    // SET_UNFOLD: (state, unfold) => {
    //   state.unfold = unfold
    // },
    SET_IFRAMES: (state, iframes) => {
      state.iframes = iframes
    },
    SET_PANES_HISTORY: (state, panes) => {
      state.panesHistory = panes
    },
    REMOVE_PANE: (state, index) => {
      state.panes.splice(index, 1)
    },
    REMOVE_IFRAME: (state, key) => {
      const index = state.iframes.map(item => item.key).indexOf(key)
      ~index && state.iframes.splice(index, 1)
    },
    ADD_PANE: (state, pane) => {
      const isExit = state.panes.find(item => item.key === pane.key)
      const replace = pane.replace
      console.log('ADD_PANE', isExit)
      if (isExit === undefined || (isExit && isExit.path !== pane.path)) {
        const curPaneIndex = state.panes.findIndex(item => item.key === state.activeKey)
        if (isExit && isExit.path !== pane.path) {
          const isExitIndex = state.panes.findIndex(item => item.key === pane.key)
          state.panes.splice(isExitIndex, 1, pane)
        } else if (replace && ~curPaneIndex) {
          state.panes.splice(curPaneIndex, 1, pane)
        } else {
          state.panes.push(pane)
        }
      }
    },
    SET_ACTIVE_KEY2: (state, key) => {
      state.activeKey = key
    },
    ADD_PANE_BY_KEY: (state, key) => {
      const pane = findPane(state.menus, { key })

      if (pane) {
        if (!state.panes.find(item => item.key === pane.key)) {
          state.panes.push(pane)
        }
      }
    },
    ADD_PANE_BY_PATH: (state, path) => {
      const [activePath, activeQuery] = path.split('?')
      const activePane = findPane(state.menus, { path: activePath, lastMenu: 2 })
      if (activePane) {
        activePane.path += activeQuery ? `?${activeQuery}` : ''
        const panesExist = state.panes.find(item => item.key === activePane.key)
        const iframesExist = state.iframes.find(item => item.key === activePane.key)

        if (!panesExist) {
          state.panes.push(activePane)
        }

        if (activePane.systemDomain && !iframesExist) {
          state.iframes.push(activePane)
        }

        state.activeKey = activePane.key
        router.push(activePane.path)
      } else {
        state.activeKey = state.homeMenuId
      }
    },
    ADD_PANE_BY_OBJECT: (state, obj) => {
      const { key, path, lastMenu, replace } = obj
      const target = {}

      key && (target.key = key)
      path && (target.path = path)
      lastMenu && (target.lastMenu = lastMenu)

      const activePane = findPane(state.menus, target)
      if (activePane) {
        const panesExist = state.panes.find(item => item.key === activePane.key)
        const iframesExist = state.iframes.find(item => item.key === activePane.key)
        const curPaneIndex = state.panes.findIndex(item => item.key === state.activeKey)
        if (replace && ~curPaneIndex) {
          state.panes.splice(curPaneIndex, 1, activePane)
        } else if (!panesExist) {
          state.panes.push(activePane)
        }

        if (activePane.systemDomain && !iframesExist) {
          if (replace && ~curPaneIndex) {
            state.panes.splice(curPaneIndex, 1, activePane)
          } else {
            state.iframes.push(activePane)
          }
        }

        state.activeKey = activePane.key
      } else {
        state.activeKey = state.homeMenuId
      }
    },
    SET_ACTIVE_KEY: (state, obj) => {
      obj.key = obj.key ? String(obj.key) : undefined
      const { key, ...other } = obj
      const activePane = state.panes.find(pane => `${pane.key}` === `${key}`)
      const panesHistoryKeys = state.panesHistory.map(item => `${item.key}`)
      activePane.key = activePane.key ? String(activePane.key) : undefined
      const isnan = isNaN(Number(key.replace('m_', '')))
      key !== 'home' && other.statisticsType && !isnan && recordMenuOpt({ ...other, menuId: Number(key.replace('m_', '')) }).then(() => { }) // 向后端统计点击
      state.activePane = activePane
      console.log('SET_ACTIVE_KEY:activePane', state.activePane, activePane)
      pushTabStack(activePane.key)
      if (activePane) {
        if (!activePane.noCache) {
          const index = panesHistoryKeys.indexOf(activePane.key)

          if (~index) {
            state.panesHistory[index].view
              ? (state.panesHistory[index].view += 1)
              : (state.panesHistory[index].view = 1)
          } else {
            state.panesHistory.unshift({ ...activePane, view: 1 })
          }

          state.panesHistory.sort((a, b) => b.view - a.view)
        }

        if (activePane.systemDomain || activePane.external) {
          const iframesExist = state.iframes.find(item => item.key === activePane.key)
          !iframesExist && state.iframes.push(activePane)
        }
        router.push(activePane.path)
      }

      state.activeKey = key
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_MENUS_ACTIVE_ID: (state, key) => {
      state.menusActiveID = key
      Vue.ls.set(MENUS_ACTIVE_ID_CACHE, key)
    },
    SET_MENUS_CACHE: (state, menusCache) => {
      state.menusCache = menusCache || {}
    },
    SET_MENUS_CACHE_ITEM: (state, item) => {
      state.menusCache[item.serviceId] = item.menus
    },
    SET_MENU_TYPE_CURRENT_ID: (state, id) => {
      state.menuTypeCurrentId = id
    },
    SET_PAID_PAGE_FLAG: (state, flag) => {
      state.paidPageFlag = flag
    },
    SET_ACTIVE_PANEL: (state, activePane) => {
      state.activePane = activePane
    },
    SET_SUB_MENUS: (state, subMenus) => {
      state.subMenus = subMenus
    }
  },
  actions: {
    GenerateMenus ({ dispatch }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const nextHome = await dispatch('GenerateSystemMenus', { ...params })
          await dispatch('QueryFavorites')
          await switchSystemCode({ systemCode: params.systemCode })
          resolve(nextHome)
        } catch (error) {
          resolve(error)
        }
      })
    },
    QueryFavorites ({ commit, state }) {
      return queryFavorites({ paging: false }).then(({ dataList }) => {
        const favorites = []
        dataList.forEach(({ menuId }) => {
          const pane = findPane(state.menus, { key: `m_${menuId}`, lastMenu: 2 })
          pane && favorites.push(pane)
        })

        commit('SET_FAVORITES', favorites)
      })
    },
    GenerateSystemMenus ({ commit }, params) {
      const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
      return new Promise(async (resolve) => {
        let menus = []
        let isExit = null
        try {
          const { code, data } = await getMenuTreeByServiceAndRole({
            ...params,
            microApps: null
          })

          if (`${code}` === '200' && data) {
            const { childMenus, homeMenuId, useNewMenu, showUpdateFlag, packageShowUpdateFlag, packageId } = data
            const activeKey = Vue.ls.get(ACTIVE_KEY_CACHE)
            const _homeMenuId = (Vue.ls.get(HOME_MENU_ID) || '').substring(2)
            const subMenus = filterSubMenus(childMenus).map((menu) => {
              const systemName = store.getters.microApps?.find(item => item.systemCode === menu.systemCode)?.name || ''
              return {
                ...menu,
                path: `/entry/${params.serviceId}/${params.systemCode}/${systemName}#${menu.menuUrl}`
              }
            })

            menus = [...getMenus(childMenus, { ...params, lang, packageId, useNewMenu, isDemo: true })]
            isExit = findPane(menus, { key: `m_${homeMenuId}` })

            console.log('按钮菜单：', subMenus)

            if (`${homeMenuId}` !== _homeMenuId && isExit && activeKey === `m_${homeMenuId}`) {
              Vue.ls.remove(PANES_CACHE)
              Vue.ls.remove(PANES_HISTORY_CACHE)
              Vue.ls.remove(MENUS_ACTIVE_ID_CACHE)
              Vue.ls.remove(ACTIVE_KEY_CACHE)
            }

            commit('SET_ACTIVE_PANEL', isExit || {})
            commit('SET_PAID_PAGE_FLAG', packageShowUpdateFlag === 2 ? false : showUpdateFlag)
            commit('SET_SUB_MENUS', subMenus)
          }
        } catch (e) {
          console.log('error', e)
        }
        const usreMenuResponse = await queryECMenuTreeByPlatformCode({})
        const isAuth = ((usreMenuResponse?.data?.menuInfoListDTOS || []).find(item => item.menuName === '权限管理')?.childMenus || []).some(item => item.selectFlag === 2)
        const embel = [
          isAuth ? {
            menuName: '权限管理',
            menuEnName: 'Authority',
            menuKrName: '권한 관리',
            menuUrl: '/embel/list'
          } : false,
          {
            menuName: '用户中心',
            menuEnName: 'User Center',
            menuKrName: '사용자 센터',
            menuUrl: '/'
          },
          {
            menuName: '用户中心',
            menuEnName: 'User Center',
            menuKrName: '사용자 센터',
            menuUrl: '/embel/home'
          },
          {
            menuName: '应用市场',
            menuEnName: 'App Store',
            menuKrName: '앱 마켓플레이스',
            menuUrl: '/app/home'
          },
          {
            menuName: '确认订单',
            menuEnName: 'Confirm The Order',
            menuKrName: '주문을 확인합니다',
            menuUrl: '/company/serve/comfirm-order'
          },
          {
            menuName: '扫码支付',
            menuEnName: 'Scan The Code To Pay',
            menuKrName: '코드를 스캔하여 지불하십시오',
            menuUrl: '/company/serve/pay-qrcode'
          },
          {
            menuName: '订单支付',
            menuEnName: 'Payment Successful',
            menuKrName: '결제가 성공했습니다',
            menuUrl: '/company/serve/pay-result'
          },
          {
            menuName: '选择升级包',
            menuEnName: 'Selecting an Upgrade Package',
            menuKrName: '업그레이드 패키지 선택',
            menuUrl: '/company/serve/buy-additional'
          },
          {
            menuName: '续费',
            menuEnName: 'Renewal',
            menuKrName: '갱신',
            menuUrl: '/company/serve/buy-renew'
          },
          {
            menuName: '直播详情',
            menuEnName: 'Live Details',
            menuKrName: '라이브 세부 정보',
            menuUrl: '/company/helper/live-roadcast/details'
          }
        ].filter(item => item).map(item => ({
          ...item,
          childMenus: [],
          closable: true,
          lastMenu: 2,
          menuId: 'entry-sso-app' + `-${item.menuEnName.replace(/\s+/g, '')}`,
          platformCode: 'SSO_SYS_USER_BASE',
          selectFlag: 2
        }))
        const userDTOS = {
          menuName: {
            zh_CN: '用户中心',
            en_US: 'User Center',
            ko_KR: '사용자 센터'
          },
          childMenus: getMenus([...usreMenuResponse?.data?.menuInfoListDTOS, ...embel], { ...params, lang, useNewMenu: 2, isDemo: true })
        }
        menus = [...menus, userDTOS]
        commit('SET_MENUS_CACHE_ITEM', { menus, ...params })
        commit('SET_HOME_MENU_ID', isExit?.key || 'home')
        commit('SET_MENUS', menus)
        resolve(isExit)
      })
    },
    GenerateCustomMenus ({ dispatch, commit, state }) {
      return new Promise(async (resolve, reject) => {
        try {
          const menus = await dispatch('GetCustomMenus', { paging: false })
          commit('SET_CUSTOM_MENUS', menus)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    GetCustomMenus ({ state }, data) {
      return new Promise((resolve, reject) => {
        customGroupQueryList(data)
          .then(res => {
            const { code, dataList } = res
            let customMenus = []

            if (`${code}` === '200' && dataList && dataList.length) {
              customMenus = dataList.map(item => {
                const {
                  id,
                  customMenuName,
                  groupMenuBindDTOS,
                  remark,
                  type
                } = item
                let childMenus = []

                if (groupMenuBindDTOS && groupMenuBindDTOS.length) {
                  childMenus = groupMenuBindDTOS.map(menu => {
                    const { menuId } = menu
                    const menuData = findPane(state.menus, {
                      menuId,
                      lastMenu: 2
                    })
                    return (
                      menuData && {
                        menuId,
                        key: menuData.key,
                        tab: menuData.tab,
                        menuName: menuData.menuName,
                        menuEnName: menuData.menuEnName,
                        menuKrName: menuData.menuKrName,
                        platformExpireTime: menuData.platformExpireTime,
                        assetsExpireTime: menuData.assetsExpireTime,
                        lastMenu: 2,
                        childMenus: []
                      }
                    )
                  })
                }

                return {
                  menuId: id,
                  key: `c_${id}`,
                  menuType: type,
                  tab: customMenuName,
                  special: data.type,
                  closable: true,
                  childMenus: childMenus.filter(item => item),
                  remark: remark || ''
                }
              })
            }
            console.log(customMenus)
            resolve(customMenus)
          })
          .catch(error => reject(error))
      })
    },
    // 获取默认自定义菜单
    GetCustomMenu ({ state }, data) {
      return new Promise((resolve, reject) => {
        customGroupQuery(data)
          .then(res => {
            const { code, data } = res
            let customMenu = null

            if (`${code}` === '200' && data) {
              const { id, groupMenuBindDTOS, remark } = data
              let childMenus = []

              if (groupMenuBindDTOS && groupMenuBindDTOS.length) {
                childMenus = groupMenuBindDTOS.map(menu => {
                  const { menuId } = menu
                  const menuData = findPane(state.menus, {
                    menuId,
                    lastMenu: 2
                  })
                  return (
                    menuData && {
                      menuId,
                      key: menuData.key,
                      tab: menuData.tab,
                      menuName: menuData.menuName,
                      menuEnName: menuData.menuEnName,
                      menuKrName: menuData.menuKrName,
                      platformExpireTime: menuData.platformExpireTime,
                      assetsExpireTime: menuData.assetsExpireTime,
                      lastMenu: 2,
                      childMenus: []
                    }
                  )
                })
              }

              customMenu = {
                menuId: id,
                key: 'c_default',
                tab: 'ERP快速上手',
                special: 3,
                closable: false,
                childMenus: childMenus.filter(item => item),
                remark: remark || ''
              }
            }

            resolve(customMenu)
          })
          .catch(error => reject(error))
      })
    },
    AddCustomMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await customGroupAdd(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    RemoveCustomMenu ({ dispatch }, groupId) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await customGroupDel({ groupId })
          await dispatch('GenerateCustomMenus')
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    EditCustomMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await customGroupEdit(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    EditSystemMenu ({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await bindMenuCustomMenu(data)
          await dispatch('GenerateCustomMenus')
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    SetActiveKey: async ({ commit, state }, obj) => {
     console.log('SetActiveKey', obj)
      obj.key = obj.key ? String(obj.key) : undefined
      const { key } = obj
      const isExit = state.panes.find(pane => `${pane.key}` === `${key}`)
      const activePane = findPane(state.menus, { key }, undefined, ['systemCode'])
      if (!activePane && !isExit) {
        console.warn('SetActiveKey:warning.obj: ', obj)
        return modal.warning({
          prefixCls: 'home-ant-modal',
          title: i18nRender('notification-modal.title.prompt'),
          content: i18nRender('layout.error-401'),
          okText: i18nRender('station.我知道了'),
          okButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          },
          cancelButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          }
        })
      }

      // 判断平台是否到期
      if (activePane && activePane.platformExpireTime && Date.now() > Date.parse(activePane.platformExpireTime)) {
        return modal.confirm({
          prefixCls: 'home-ant-modal',
          title: '温馨提示',
          content: '该功能的平台已到期，为避免影响团队成员正常使用，请尽快完成续费',
          okText: '续费',
          cancelText: '取消',
          onOk () {
            window.location.href = ((process.env.SSO_ENV || '') + '/#/company/serve/serve-manage').replace(/^\/?/, '/')
          },
          okButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          },
          cancelButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          }
        })
      }

      // 判断功能是否到期
      if (activePane && activePane.assetsExpireTime && Date.now() > Date.parse(activePane.assetsExpireTime)) {
        const systemName = store.getters.systemCodes?.find(item => item.systemCode === activePane.systemCode)?.systemName || ''
        return modal.confirm({
          prefixCls: 'home-ant-modal',
          zIndex: 2000,
          title: '温馨提示',
          content: `当前页面所属的${systemName}应用已过期，不支持使用，请及时续费`,
          okText: '续费',
          cancelText: '取消',
          onOk () {
            if (activePane.assetsType === 2) {
              //
              store.dispatch('SetLocalDefaultConfig', {
                appTabCur: 1
              })
              const { params: { serviceId, systemCode } } = router?.app?._route
              store.dispatch('entry/SetActiveAsync', {
                path: `/entry/${serviceId}/${systemCode}/sso-web#/app/home`
              })
            } else {
              window.location.href = ((process.env.SSO_ENV || '') + '/#/company/serve/serve-manage').replace(/^\/?/, '/')
            }
          },
          okButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          },
          cancelButtonProps: {
            props: {
              prefixCls: `home-ant-btn`
            }
          }
        })
      }

      if (isExit || key === 'home') {
        commit('SET_ACTIVE_KEY', obj)
      } else if (activePane) {
        commit('ADD_PANE_BY_OBJECT', obj)
        commit('SET_ACTIVE_KEY', obj)
      }
    },
    SetActiveAsync ({ commit, state }, pane) {
      return new Promise((resolve, reject) => {
        const defaultOptions = {
          verify: 'warning',
          next: true,
          routerMethods: 'push', // push | replace | go | back | forward
          noCache: true,
          external: false,
          replace: false,
          ignore: false
        }
        const {
          systemName,
          menuName,
          systemCode,
          verify,
          next,
          noCache,
          routerMethods,
          replace,
          external,
          key,
          ignore,
          menuParams,
          ...target
        } = { ...defaultOptions, ...pane }
        const pathDots = (target?.path || '').split('?')

        if (pathDots.length === 2) {
          target.path = pathDots[0]
        }
        if (target.menuUrl) {
          target.menuUrl = target.menuUrl.split('?')[0]
        }
        const activePane = (!external && !ignore)
          ? findPane(state.menus, target)
          : {
            menuUrl: target.menuUrl,
            path: target.path,
            menuName,
            key: key || target.path || target.menuUrl,
            closable: true,
            external,
            ignore,
            noCache: false
          }

        if (activePane) {
          if (activePane.key.length >= 40) {
            activePane.key = md5(activePane.key)
          }
          menuName && (activePane.menuName = menuName)
          pathDots.length === 2 && (activePane.path = activePane.path + '?' + pathDots[1].replace(/^&/, ''))
          !noCache && (() => {
            const panesHistoryKeys = state.panesHistory.map(item => item.key)
            const index = panesHistoryKeys.indexOf(activePane.key)

            if (~index) {
              state.panesHistory[index].view
                ? (state.panesHistory[index].view += 1)
                : (state.panesHistory[index].view = 1)
            } else {
              state.panesHistory.unshift({ ...activePane, view: 1 })
            }

            state.panesHistory.sort((a, b) => b.view - a.view)
          })()
        } else if (verify) {
          const error = {
            prefixCls: 'home-ant-modal',
            code: 401,
            title: i18nRender('notification-modal.title.prompt'),
            content: i18nRender('layout.error-401'),
            okText: i18nRender('station.我知道了'),
            okButtonProps: {
              props: {
                prefixCls: `home-ant-btn`
              }
            },
            cancelButtonProps: {
              props: {
                prefixCls: `home-ant-btn`
              }
            }
          }
          modal.destroyAll()
          verify === 'warning' && modal.warning(error)
          console.warn('No menu permissions! params:', target)
          reject(error)
          return
        }

        if ((activePane?.systemDomain && (systemName === 'iframe' || !systemName)) || external) {
          if (menuParams) {
            activePane.menuParams = menuParams
          }
          const iframesExist = state.iframes.findIndex(item => item.key === activePane.key)
          !~iframesExist ? state.iframes.push(activePane) : state.iframes.splice(iframesExist, 1, activePane)
        }
        activePane && commit('ADD_PANE', { ...activePane, replace })
        activePane?.key && commit('SET_ACTIVE_KEY2', activePane.key)

        next && activePane && router[routerMethods](`${activePane.path}`)
        if (activePane) {
          resolve(activePane)
        } else {
          reject(new Error('activePane undefined'))
        }
      })
    },
    Navigator ({ commit }, pane) {
      commit('ADD_PANE', { ...pane })
      commit('SET_ACTIVE_KEY', { ...pane })
    },
    ClosePane ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      // 首页不可关闭
      if (index > 0) {
        commit('REMOVE_PANE', index)
        commit('REMOVE_IFRAME', key)
        return Promise.resolve({ key: state.panes[index - 1]?.key || state.homeMenuId })
      }

      return Promise.resolve({ key: getTagStackTop(state.panes) || state.homeMenuId })
    },
    CloseAllPane ({ commit, state }) {
      const homeMenu = state.panes.find(item => !item.closable)
      commit('SET_PANES', [homeMenu && homeMenu])
      commit('SET_IFRAMES', [])
      commit('SET_ACTIVE_KEY', { key: state.homeMenuId })
    },
    CloseLeftPanes ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      const homeMenu = state.panes.find(item => !item.closable)
      if (index === 0) {
        return
      }
      if (~index) {
        commit('SET_PANES', [homeMenu && homeMenu, ...state.panes.slice(index)])
        commit('SET_IFRAMES', state.iframes.filter(item => item.key === key))
      }
    },
    CloseRightPanes ({ commit, state }, key) {
      const keys = state.panes.map(item => item.key)
      const index = keys.indexOf(key)
      if (index === 0) {
        return
      }
      if (state.activeKey === 'home' && keys.length) {
        commit('SET_PANES', [])
        commit('SET_IFRAMES', [])
      } else if (~index && index !== keys.length - 1) {
        commit('SET_PANES', state.panes.slice(0, index + 1))
        commit('SET_IFRAMES', state.iframes.filter(item => item.key === key))
      }
    },
    // 将二级菜单钉到左侧菜单
    PushpinMenu ({ state }, { key, pushpin }) {
      state.menus.forEach(({ childMenus }) => {
        childMenus.forEach(item => {
          if (item.key === key) {
            item.pushpin = !item.pushpin
          }
        })
      })
      collectMenu({ menuId: key.replace('m_', ''), optType: pushpin ? 1 : 2 })
    },
    // 收藏页面
    AddFavorites ({ commit }, { key }) {
      const menuId = key.replace('m_', '')
      return addFavorites({ menuId }).then(res => {
        commit('ADD_FAVORITES', { key })
      })
    },
    // 取消收藏
    DelFavorites ({ commit }, { key }) {
      const menuId = key.replace('m_', '')
      return delFavorites({ menuId }).then(res => {
        commit('DEL_FAVORITES', { key })
      })
    },
    async SavePanes ({ state }) {
      const { serviceId, systemCode } = state
      const CACHE_KEY = `${serviceId}${systemCode}`
      const panesCache = Vue.ls.get(PANES_CACHE) || {}
      const panesHistoryCache = Vue.ls.get(PANES_HISTORY_CACHE) || {}
      const activeKeyCache = Vue.ls.get(ACTIVE_KEY_CACHE) || {}
      Vue.ls.set(PANES_CACHE, {
        ...panesCache,
        [CACHE_KEY]: state.panes.filter(item => item.closable) // 不保存首页
      })
      Vue.ls.set(ACTIVE_KEY_CACHE, {
        ...activeKeyCache,
        [CACHE_KEY]: state.activeKey
      })
      Vue.ls.set(PANES_HISTORY_CACHE, {
        ...panesHistoryCache,
        [CACHE_KEY]: state.panesHistory
      })
    },
    async InitPanes ({ commit, state, dispatch }, { serviceId, systemCode, activePath }) {
      commit('SET_SERVICE_ID', serviceId)
      commit('SET_SYSTEM_CODE', systemCode)
      try {
        await dispatch('GenerateCustomMenus')
      } catch (e) { }

      const CACHE_KEY = `${serviceId}${systemCode}`
      const activeKeyCache = Vue.ls.get(ACTIVE_KEY_CACHE) || {}
      const panesCache = Vue.ls.get(PANES_CACHE) || {}
      const panesHistoryCache = Vue.ls.get(PANES_HISTORY_CACHE) || {}
      // const userInfo = Vue.ls.get(USER_INFO) || {}
      const menusActiveID = Vue.ls.get(MENUS_ACTIVE_ID_CACHE) || (state.customMenus.length && state.customMenus[0].key) || '__HISTORY__'
      const panes = [Object.assign({ key: 'home', tab: '首页' }, findPane(state.menus, { key: state.homeMenuId }), { noCache: true, closable: false })]
      const panesHistory = []
      const activeKey = activeKeyCache[CACHE_KEY]?.length < 40 ? activeKeyCache[CACHE_KEY] : (state.homeMenuId || 'home')
      // 获取历史打开页面
      if (panesCache[CACHE_KEY]?.length) {
        panes.push(
          ...panesCache[CACHE_KEY].map((item) => {
            if (item.external || item.ignore) {
              return item
            }
            return findPane(state.menus, { key: item.key, lastMenu: 2 }, { path: item.path })
          }).filter(item => item && item.key !== state.homeMenuId)
        )
      }

      // 获取历史记录
      if (panesHistoryCache[CACHE_KEY]?.length) {
        panesHistory.push(
          ...panesHistoryCache[CACHE_KEY].map(item =>
            findPane(state.menus, { key: item.key, lastMenu: 2 })
          ).filter(item => item)
        )
      }

      // 获取用户状态（展开|收缩左侧菜单开关）
      // queryMenuStatus({}).then(({ data }) => {
      //   const unfold = data.saveMenuStatus === null ? true : JSON.parse(data.saveMenuStatus)
      //   commit('SET_UNFOLD', unfold)
      // })

      // 获取用户顶部样式风格
      commit('SET_MENUS_ACTIVE_ID', menusActiveID)
      commit('SET_PANES', panes)
      commit('SET_PANES_HISTORY', panesHistory)

      initTabStack()

      /**
       * 优先匹配当前路径
       * 其次匹配上次访问的页面
       * 否则打开首页
       */
      if (/#/.test(activePath)) {
        const activePane = panes.find(item => item.key === activeKey)
        const { hash } = router.currentRoute
        state.activePane = activePane
        if (activePane?.external || activePane?.ignore) {
          activePane.external && state.iframes.push(activePane)
          state.activeKey = activePane.key
          router.push({ path: activePane.path })
        } else if (/#\/guide/.test(hash)) {
          const guidePane = {
            key: 'scm_new_guide',
            systemCode: 'SCM_NEW',
            path: `/entry/${serviceId}/${systemCode}/scm_new#/guide`,
            menuName: { zh_CN: '初始化引导', en_US: '初始化引导', ko_KR: '初始化引导' },
            noCache: true,
            ignore: true,
            closable: true
          }
          commit('ADD_PANE', guidePane)
          state.activeKey = 'scm_new_guide'
        } else {
          commit('ADD_PANE_BY_PATH', activePath)
        }
      } else if (['Entry401', 'Entry402', 'Entry404'].includes(router.currentRoute.name)) {
        console.log('this.$route', router.currentRoute)
      } else {
        dispatch('SetActiveKey', { key: activeKey })
      }
    },
    findPane ({ state }, target = {}) {
      return new Promise((resolve, reject) => {
        const pane = findPane(state.menus, target)
        if (pane) {
          resolve(pane)
        } else {
          reject(new Error('找不到对应的菜单'))
        }
      })
    },
    modifyPanePath ({ state }, hash) {
      const { path } = router.currentRoute
      const pane = state.panes.find((item) => item.key === state.activeKey)
      if (pane) {
        pane.path = path + '#' + hash
      }
    }
  }
}

export default entry
